"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const ObfuscationEvent_1 = require("../../enums/event-emitters/ObfuscationEvent");
const Initializable_1 = require("../../decorators/Initializable");
const SingleNodeCallControllerTemplate_1 = require("../../templates/SingleNodeCallControllerTemplate");
const NoCustomNodes_1 = require("../../options/presets/NoCustomNodes");
const AbstractCustomNode_1 = require("../AbstractCustomNode");
const JavaScriptObfuscatorFacade_1 = require("../../JavaScriptObfuscatorFacade");
const NodeUtils_1 = require("../../node/NodeUtils");
let NodeCallsControllerFunctionNode = class NodeCallsControllerFunctionNode extends AbstractCustomNode_1.AbstractCustomNode {
    constructor(identifierNamesGeneratorFactory, customNodeFormatter, randomGenerator, options) {
        super(identifierNamesGeneratorFactory, customNodeFormatter, randomGenerator, options);
    }
    initialize(appendEvent, callsControllerFunctionName) {
        this.appendEvent = appendEvent;
        this.callsControllerFunctionName = callsControllerFunctionName;
    }
    getNodeStructure(nodeTemplate) {
        return NodeUtils_1.NodeUtils.convertCodeToStructure(nodeTemplate);
    }
    getNodeTemplate() {
        if (this.appendEvent === ObfuscationEvent_1.ObfuscationEvent.AfterObfuscation) {
            return JavaScriptObfuscatorFacade_1.JavaScriptObfuscator.obfuscate(this.customNodeFormatter.formatTemplate(SingleNodeCallControllerTemplate_1.SingleNodeCallControllerTemplate(), {
                singleNodeCallControllerFunctionName: this.callsControllerFunctionName
            }), Object.assign(Object.assign({}, NoCustomNodes_1.NO_ADDITIONAL_NODES_PRESET), { identifierNamesGenerator: this.options.identifierNamesGenerator, identifiersDictionary: this.options.identifiersDictionary, seed: this.options.seed })).getObfuscatedCode();
        }
        return this.customNodeFormatter.formatTemplate(SingleNodeCallControllerTemplate_1.SingleNodeCallControllerTemplate(), {
            singleNodeCallControllerFunctionName: this.callsControllerFunctionName
        });
    }
};
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", String)
], NodeCallsControllerFunctionNode.prototype, "callsControllerFunctionName", void 0);
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", String)
], NodeCallsControllerFunctionNode.prototype, "appendEvent", void 0);
NodeCallsControllerFunctionNode = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.ICustomNodeFormatter)),
    __param(2, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(3, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Function, Object, Object, Object])
], NodeCallsControllerFunctionNode);
exports.NodeCallsControllerFunctionNode = NodeCallsControllerFunctionNode;
